import fetch, { Headers, Request, Response } from 'cross-fetch';
export { Headers, Request, Response };
export default fetch;
//# sourceMappingURL=fetch.js.map